import gradientMobile from '../assets/decor/gradient_mobile.png';
import gradientTablet from '../assets/decor/gradient_tablet.png';
import gradientDesktop from '../assets/decor/gradient_desktop.png';
import scales from '../assets/decor/scales.png';
import wavesGold from '../assets/decor/waves_bottom_gold.svg';
import circleOutlineGold from '../assets/decor/circle_outline_gold.svg';
import starGold from '../assets/decor/star_gold.svg';
import sparkleCluster from '../assets/decor/sparkle_cluster.svg';

/**
 * Decorative splash background, layered from the separate suitUp assets
 * (gradient + scales illustration + gold waves, circle, stars).
 * The scales illustration is used as-is (original, unprocessed).
 */
const WelcomeBackground = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
    {/* base warm gradient */}
    <picture>
      <source media="(min-width: 1024px)" srcSet={gradientDesktop} />
      <source media="(min-width: 640px)" srcSet={gradientTablet} />
      <img src={gradientMobile} alt="" className="h-full w-full object-cover object-center" />
    </picture>

    {/* faint outline circle, mid-right */}
    <img
      src={circleOutlineGold}
      alt=""
      className="absolute right-[8%] top-[38%] w-40 opacity-30 lg:right-[20%] lg:top-[30%] lg:w-56"
    />

    {/* scattered gold stars + sparkle cluster */}
    <img src={sparkleCluster} alt="" className="absolute right-[10%] top-[10%] w-24 opacity-80 lg:right-[26%] lg:w-28" />
    <img src={starGold} alt="" className="absolute right-[6%] top-[24%] w-6 opacity-70 lg:w-7" />
    <img src={starGold} alt="" className="absolute left-[16%] top-[16%] w-4 opacity-50 lg:left-[30%]" />
    <img src={starGold} alt="" className="absolute right-[24%] top-[6%] w-3 opacity-60 lg:right-[40%]" />
    <img src={starGold} alt="" className="absolute right-[38%] top-[20%] w-5 opacity-50 lg:right-[48%]" />
    <img src={starGold} alt="" className="absolute left-[8%] top-[30%] w-3 opacity-40 lg:left-[22%]" />
    <img src={starGold} alt="" className="absolute right-[14%] top-[44%] w-4 opacity-45 lg:right-[34%] lg:top-[50%]" />
    <img src={starGold} alt="" className="absolute left-[28%] top-[8%] w-3 opacity-55 lg:left-[42%]" />
    <img src={starGold} alt="" className="absolute right-[2%] top-[52%] w-4 opacity-40 lg:right-[16%]" />

    {/* thin gold wave lines pinned to the bottom */}
    <img src={wavesGold} alt="" className="absolute inset-x-0 bottom-0 w-full opacity-70" />

    {/* scales of justice — mobile: aligned with the "התחל כאן" heading; desktop: bottom-left */}
    <img
      src={scales}
      alt=""
      className="absolute -left-16 top-[20%] w-60 lg:-left-12 lg:top-auto lg:bottom-16 lg:w-[42rem]"
    />
  </div>
);

export default WelcomeBackground;
